import React from 'react';

import { styled } from '@compiled/react';
import { useIntl } from 'react-intl-next';

import { fg } from '@atlaskit/platform-feature-flags';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import messages from './messages';

const redactionBarStyles = xcss({
	display: 'inline-flex',
	aspectRatio: '3.4/1',
	height: '1lh',
	'@supports not (height: 1lh)': {
		height: '1.5em',
	},
	backgroundColor: 'color.background.neutral.bold.pressed',
	verticalAlign: 'middle',
	position: 'relative',
});

export function RedactionMarker() {
	const { formatMessage } = useIntl();

	if (fg('jira-redaction-accessibility-followup')) {
		return <RedactionBar aria-label={formatMessage(messages.redactionMarker)} />;
	}
	return <Box as="span" xcss={redactionBarStyles} />;
}

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const RedactionBar = styled.span({
	display: 'inline-flex',
	aspectRatio: '3.4/1',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
	height: CSS.supports('height', '1lh') ? '1lh' : '1.5em',
	backgroundColor: token('color.text'),
	verticalAlign: 'middle',
	position: 'relative',
});
